
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Benefit } from '../../../models/benefit.model';
import { AlertService } from '../../../services/alert.service';
import { ActivatedRoute } from '@angular/router';
import { ProductBenefit } from '../../../models/product-benefit.model';
import * as _ from 'lodash';
import { Product } from '../../../models/product.model';
import { VendorProductLookup } from '../../../models/vendor-product-lookup.model';
import { Observable } from 'rxjs/Observable';
import { Vendor } from '../../../models/vendor.model';


@Component({
    selector: 'vendor-product-lookup-modal',
    template: require('./vendor-product-lookup-modal.component.html'),
    styles: [require('./vendor-product-lookup-modal.component.css')]
})
export class VendorProductLookupModalComponent {
    vendorId: number;
    vendor: Vendor;
    candidateVendorProductLookups: VendorProductLookup[];
    existedVendorProductLookups: VendorProductLookup[];

    constructor(private route: ActivatedRoute, private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<VendorProductLookupModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.vendorId = data.vendorId;
        this.vendor = data.vendor;
        this.init();
    }

    init() {
        this.candidateVendorProductLookups = [];
        this.existedVendorProductLookups = [];
        Observable.forkJoin([
            this.getAvailableProductsForVendor(),
            this.getExistedVendorProductLookups()
        ]).subscribe(results => {
            var availableProducts = results[0];
            this.existedVendorProductLookups = results[1];
            _.each(availableProducts, ap => {

                var existing = _.some(this.existedVendorProductLookups, vpl => {
                    return vpl.productId == ap.productId && vpl.vendorId == this.vendorId;
                })

                if (!existing) {
                    this.candidateVendorProductLookups.push(new VendorProductLookup({product: ap, productId: ap.productId, vendorId: this.vendorId, vendorProductId:"" }));
                }
            });
        });


    }

    getAvailableProductsForVendor() {
       return this.apiService.getAvailableProductsForVendor(this.vendorId);
    }

    getExistedVendorProductLookups() {
        return this.apiService.getExistedVendorProductLookups(this.vendorId);
    }

    removeVendorProductLookup(vpl: VendorProductLookup) {
        this.apiService.removeVendorProductLookup(vpl).subscribe(r => {
            this.init();
        })
    }

   addVendorProductLookup(vpl: VendorProductLookup) {
        this.apiService.addVendorProductLookup(vpl).subscribe(r => {
            this.init();
        })
    }

    ok() {
        //var selectedBenefits = _.filter(this.benefits, { 'isSelected': true });

        //var productBenefits = _.map(selectedBenefits, i => {
        //    return new ProductBenefit({ benefitId: i.benefitId, productId: this.productId });
        //})
        //this.apiService.createProductBenefitsBulk(productBenefits).subscribe(r => {
        //    if (r) {
        //        this.dialogRef.close(r);
        //    }
        //});
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/vendors/vendor-product-lookup-modal/vendor-product-lookup-modal.component.ts